import { useContext } from 'react';

import WizardContext from './WizardContext';

const useWizardContext = () => {
  const context = useContext(WizardContext);

  if (!context) {
    throw new Error('useWizardContext must be used within a WizardPlayer component');
  }

  return context;
};

export default useWizardContext;
